import { render, staticRenderFns } from "./getUserType.vue?vue&type=template&id=5c7d793a&scoped=true&"
import script from "./getUserType.vue?vue&type=script&lang=js&"
export * from "./getUserType.vue?vue&type=script&lang=js&"
import style0 from "./getUserType.vue?vue&type=style&index=0&id=5c7d793a&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7d793a",
  null
  
)

export default component.exports